AFRAME.registerComponent('watchlist-table', {
    schema: {
        width:  { type: 'number', default: 1.8 },
        height: { type: 'number', default: 1.0 },
    },

    ROWS_PER_PAGE: 10,

    init: function () {
        this.tableEntity = null;
        this.bgPanel = null;
        this.paginationEntity = null;
        this.isVisible = false;
        this.isCompact = false;

        this.fullTableData = null;
        this.currentPage = 0;
        this.totalPages = 1;
        this.lastPageClickTime = 0;

        this.el.sceneEl.addEventListener('watchlist-show-table', this._onShowTable.bind(this));
        this.el.sceneEl.addEventListener('watchlist-show-chart', this._onHide.bind(this));

        this.el.sceneEl.addEventListener('theme-changed', () => {
            if (this.isVisible) {
                this._renderCurrentPage();
            }
        });
    },

    show: function (tableData) {
        if (!tableData || tableData.length === 0) {
            console.warn('[WatchlistTable] show() called with empty data');
            return;
        }

        this.el.setAttribute('visible', true);
        this.isVisible = true;

        this.fullTableData = tableData;
        this.currentPage = 0;
        const dataRowCount = tableData.length - 1;
        this.totalPages = Math.max(1, Math.ceil(dataRowCount / this.ROWS_PER_PAGE));

        this._renderCurrentPage();
    },

    hide: function () {
        this._clearContent();
        this.el.setAttribute('visible', false);
        this.isVisible = false;
        this.fullTableData = null;
        this.currentPage = 0;
        this.totalPages = 1;
        this.lastPageClickTime = 0;
    },

    _getPageData: function () {
        if (!this.fullTableData || this.fullTableData.length === 0) return [];

        const header = this.fullTableData[0];
        const allRows = this.fullTableData.slice(1);
        const start = this.currentPage * this.ROWS_PER_PAGE;
        const end = start + this.ROWS_PER_PAGE;
        const pageRows = allRows.slice(start, end);

        return [header, ...pageRows];
    },

    _goToPage: function (page) {
        if (page < 0 || page >= this.totalPages) return;
        this.currentPage = page;
        this._renderCurrentPage();
    },

    setCompactMode: function (isCompact) {
        if (this.isCompact === isCompact) return;
        this.isCompact = isCompact;
        if (this.isVisible) {
            this._renderCurrentPage();
        }
    },

    _renderCurrentPage: function () {
        let pageData = this._getPageData();
        if (!pageData || pageData.length === 0) return;
        
        if (this.isCompact) {
            pageData = pageData.map(row => row.slice(0, -2));
        }

        const settings = (typeof getCacheItem === 'function') ? getCacheItem('mainSettings') : null;
        const isLight = settings && settings.themeMode === 'Light';

        const headerTextColor  = isLight ? '#14141C' : '#ffffff';
        const headerBgColor    = isLight ? '#E0E0E0' : '#222222';
        const rowColor1        = isLight ? '#ffffff' : '#1a1a1a';
        const rowColor2        = isLight ? '#f5f5f5' : '#151515';
        const textColor        = isLight ? '#14141C' : '#cccccc';
        const panelColor       = isLight ? '#f5f5f5' : '#191920';
        const positiveColor    = isLight ? '#008800' : '#00ff00';
        const negativeColor    = isLight ? '#cc0000' : '#ff0000';

        const tableWidth = this.isCompact ? 0.75 : 1.21;
        const rowHeight  = 0.065;
        const visibleHeight = 0.72;
        const panelPadding = 0.07;
        const panelHeight = 0.95; 
        this._clearContent();

        this.bgPanel = document.createElement('a-rounded-box');
        this.bgPanel.setAttribute('width',  tableWidth + 0.05);
        this.bgPanel.setAttribute('height', panelHeight);
        this.bgPanel.setAttribute('depth',  0.02);
        this.bgPanel.setAttribute('radius', 0.05);
        this.bgPanel.setAttribute('color',  panelColor);
        this.bgPanel.setAttribute('opacity', 0.92);
        this.bgPanel.setAttribute('position', `0 -0.32 0`);
        this.el.appendChild(this.bgPanel);

        this._renderSummary(tableWidth, isLight, positiveColor, negativeColor);
        this.tableEntity = document.createElement('a-entity');
        this.tableEntity.setAttribute('position', `0 0 0.02`);

        this.tableEntity.setAttribute('table', {
            width:               tableWidth,
            rowHeight:           rowHeight,
            headerColor:         headerTextColor,
            headerBgColor:       headerBgColor,
            rowColor1:           rowColor1,
            rowColor2:           rowColor2,
            textColor:           textColor,
            equalColumns:        true,
            visibleHeight:       visibleHeight,
            data:                JSON.stringify(pageData),
            conditionalColoring: true,
            positiveColor:       positiveColor,
            negativeColor:       negativeColor,
            textScale:           0.14,
            uiButtonFontSize:    0.035
        });

        this.el.appendChild(this.tableEntity);

        const settingsBtn = document.createElement('a-entity');
        settingsBtn.setAttribute('position', `${tableWidth / 2 - 0.05} 0.1 0.02`);
        settingsBtn.setAttribute('ui-button', {
            image: "/vr-assets/right-container-buttons/configure.png",
            width: 0.06,
            height: 0.06,
            depth: 0.015,
            type: "rounded-box",
            colorScheme: 'primary',
            radius: 0.012,
            hoverScale: 1.1,
            clickScale: 1
        });
        settingsBtn.setAttribute('data-raycastable', '');
        settingsBtn.addEventListener('click', () => {
            if (window.PopupManager) {
                window.PopupManager.open('watchlist-settings-popup');
            }
        });
        this.el.appendChild(settingsBtn);

        setTimeout(() => {
            if (this.tableEntity && this.tableEntity.components && this.tableEntity.components.table) {
                this.tableEntity.components.table.renderTable();
            }
        }, 150);

        if (this.totalPages > 1) {
            this._renderPaginationControls(tableWidth, visibleHeight, panelPadding, isLight);
        }

        this._createRepositionHandle(visibleHeight);
    },

    _createRepositionHandle: function(visibleHeight) {
        const existing = this.el.querySelector('#move-watchlist-table-area');
        if (existing) existing.remove();

        const handle = document.createElement('a-rounded-box');
        handle.setAttribute('id', 'move-watchlist-table-area');
        handle.setAttribute('width', 0.93);
        handle.setAttribute('height', 0.05);
        handle.setAttribute('depth', 0.01);
        handle.setAttribute('color', '#7676E3');
        handle.setAttribute('opacity', 0.5);
        handle.setAttribute('radius', 0.02);
        handle.setAttribute('position', `0 0.22 0.1`); 
        handle.setAttribute('visible', false);
        handle.setAttribute('drag-move', 'target: #watchlist-table');
        
        this.el.appendChild(handle);
    },

    _renderSummary: function (tableWidth, isLight, positiveColor, negativeColor) {
        const WA = window.WatchlistApp || {};
        const State = WA.State || {};
        const summaryData = State.summary;
        
        const existing = document.getElementById('watchlist-summary-container');
        if (existing) existing.remove();

        const textColor = isLight ? '#14141C' : '#FFFFFF';
        const labelColor = isLight ? '#666666' : '#BBBBBB';
        const valueColorDefault = isLight ? '#14141C' : '#FFFFFF';
        
        const container = document.createElement('a-entity');
        container.setAttribute('id', 'watchlist-summary-container');
        container.setAttribute('position', `0 -0.71 0.02`); 
        this.el.appendChild(container);

        const textScale = this.isCompact ? '0.1 0.1 0.1' : '0.14 0.14 0.14';
        const scaleFactor = this.isCompact ? (0.1 / 0.14) : 1.0;

        const col1LabelX = -tableWidth / 2 + 0.04;
        const col1Val1X = col1LabelX + 0.32 * scaleFactor;
        const col1Val2X = col1LabelX + 0.32 * scaleFactor;

        const col2LabelX = this.isCompact ? 0.02 : 0.05;
        const col2Val1X = col2LabelX + 0.27 * scaleFactor;
        const col2Val2X = col2LabelX + 0.27 * scaleFactor;

        const createField = (label, value, labelX, valueX, y, valColor) => {
            const group = document.createElement('a-entity');
            group.setAttribute('position', `0 ${y} 0`);

            const lbl = document.createElement('a-text');
            lbl.setAttribute('value', label);
            lbl.setAttribute('width', 4);
            lbl.setAttribute('color', labelColor);
            lbl.setAttribute('align', 'left');
            lbl.setAttribute('anchor', 'left');
            lbl.setAttribute('position', `${labelX} 0 0`);
            lbl.setAttribute('scale', textScale);
            group.appendChild(lbl);

            const val = document.createElement('a-text');
            val.setAttribute('value', value);
            val.setAttribute('width', 4);
            val.setAttribute('color', valColor);
            val.setAttribute('align', 'left');
            val.setAttribute('anchor', 'left');
            val.setAttribute('position', `${valueX} 0 0`);
            val.setAttribute('scale', textScale);
            group.appendChild(val);

            container.appendChild(group);
        };

        const totalDay = (summaryData && summaryData.totalDayChange) || 0;
        const totalDayPerc = (summaryData && summaryData.totalDayChangePerc) || 0;
        const totalPort = (summaryData && summaryData.totalPortfolioChange) || 0;
        const totalPortPerc = (summaryData && summaryData.totalPortfolioChangePerc) || 0;
        const portValue = (summaryData && summaryData.currentPortfolioValue) || 0;
        const costBasis = (summaryData && summaryData.totalCostBasis) || 0;

        const formatChange = (val, perc) => {
            const sign = val >= 0 ? '+' : '-';
            const absVal = Math.abs(val);
            const absPerc = Math.abs(perc);
            let valStr = Math.round(absVal).toLocaleString('en-US');
            
            if (window.WatchlistApp && window.WatchlistApp.Utils && window.WatchlistApp.Utils.truncateInputDisplay) {
                valStr = window.WatchlistApp.Utils.truncateInputDisplay(valStr, 10);
            }
            
            return `${sign}$${valStr} (${sign}${absPerc.toFixed(1)}%)`;
        };

        const dayChangeText = formatChange(totalDay, totalDayPerc);
        const dayChangeColor = totalDay >= 0 ? positiveColor : negativeColor;

        const portChangeText = formatChange(totalPort, totalPortPerc);
        const portChangeColor = totalPort >= 0 ? positiveColor : negativeColor;

        const portValueText = `$${Math.round(portValue).toLocaleString('en-US')}`;
        const costBasisText = `$${Math.round(costBasis).toLocaleString('en-US')}`;

        createField('Total day change:', dayChangeText, col1LabelX, col1Val1X, 0.0, dayChangeColor);
        createField('Total Portfolio Value:', portValueText, col2LabelX, col2Val1X, 0.0, valueColorDefault);

        createField('Total portfolio gain/loss:', portChangeText, col1LabelX, col1Val2X, -0.05, portChangeColor);
        createField('Total Cost Basis:', costBasisText, col2LabelX, col2Val2X, -0.05, valueColorDefault);
    },

    _renderPaginationControls: function (tableWidth, visibleHeight, panelPadding, isLight) {
        const btnWidth = 0.1;
        const btnHeight = 0.06;
        const btnGap = 0.2;
        const textColor = isLight ? '#000000' : '#ffffff';

        const container = document.createElement('a-entity');
        container.setAttribute('position', `0 0.1 0.02`); 
        this.el.appendChild(container);
        this.paginationEntity = container;

        const prevBtn = document.createElement('a-entity');
        prevBtn.setAttribute('position', `${-btnGap} 0 0`);
        prevBtn.setAttribute('visible', this.currentPage > 0);
        prevBtn.setAttribute('ui-button', {
            label: '<',
            width: btnWidth,
            height: btnHeight,
            colorScheme: 'primary',
            type: 'rounded-box',
            radius: 0.01,
            depth: 0.03,
            preferredFontSize: 0.035,
            textZp: 0.016
        });
        prevBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            if (this.currentPage > 0) {
                this.currentPage--;
                this._renderCurrentPage();
            }
        });
        container.appendChild(prevBtn);

        const pageText = document.createElement('a-troika-text');
        pageText.setAttribute('value', `${this.currentPage + 1} / ${this.totalPages}`);
        pageText.setAttribute('align', 'center');
        pageText.setAttribute('color', textColor);
        pageText.setAttribute('font-size', '0.02');
        pageText.setAttribute('anchor', 'center');
        pageText.setAttribute('position', '0 0 0');
        container.appendChild(pageText);

        const nextBtn = document.createElement('a-entity');
        nextBtn.setAttribute('position', `${btnGap} 0 0`);
        nextBtn.setAttribute('visible', this.currentPage < this.totalPages - 1);
        nextBtn.setAttribute('ui-button', {
            label: '>',
            width: btnWidth,
            height: btnHeight,
            colorScheme: 'primary',
            type: 'rounded-box',
            radius: 0.01,
            depth: 0.03,
            preferredFontSize: 0.035,
            textZp: 0.016
        });
        nextBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            if (this.currentPage < this.totalPages - 1) {
                this.currentPage++;
                this._renderCurrentPage();
            }
        });
        container.appendChild(nextBtn);
    },

    _clearContent: function () {
        while (this.el.firstChild) {
            this.el.removeChild(this.el.firstChild);
        }
        this.tableEntity = null;
        this.bgPanel = null;
        this.paginationEntity = null;
    },

    _onShowTable: function () {
        this.el.sceneEl.emit('watchlist-table-request-data');
    },

    _onHide: function () {
        this.hide();
    },
});
